import { Inject, Injectable } from '@angular/core';
import { ActionTypeModel } from '../../../shared';
import { actionMessages } from './action-required.constants';
import * as i0 from "@angular/core";
import * as i1 from "../../../basic-features";
import * as i2 from "@ngx-translate/core";
import * as i3 from "@angular/router";
export class ActionRequiredService {
  bannerService;
  translate;
  router;
  portalLink;
  message;
  MEMBERSHIP_ACCEPT_PATH = 'administration/profile/memberships';
  constructor(bannerService, translate, router, portalLink) {
    this.bannerService = bannerService;
    this.translate = translate;
    this.router = router;
    this.portalLink = portalLink;
  }
  handleMessageCreation(state) {
    const {
      userActionRequired,
      actionType
    } = state;
    if (actionType === ActionTypeModel.CLOSE_BANNER) {
      this.hideBanner();
      return;
    }
    if (!userActionRequired) return;
    switch (actionType) {
      case ActionTypeModel.ACCEPT_MEMBERSHIP_BANNER_ACTION:
        {
          if (this.isOnMemberShipAcceptedPage()) break;
          this.message = this.createBannerInfoMessage(actionType, this.gotoProfile.bind(this));
          break;
        }
      case ActionTypeModel.RELOAD_PAGE_BANNER_ACTION:
        this.message = this.createBannerInfoMessage(actionType, this.reloadPage.bind(this));
        break;
      default:
        this.hideBanner();
    }
  }
  createBannerInfoMessage(actionType, onBtnClick) {
    this.bannerService.clear(this.message?.key);
    const message = actionMessages.get(actionType);
    const geaMessage = {
      severity: 'info',
      detail: this.translate.instant(message?.detail ?? ''),
      data: {
        bannerButtonLabel: this.translate.instant(message?.buttonText ?? ''),
        hasBannerButton: true,
        hasCloseButton: true,
        bannerButtonClicked: () => {
          onBtnClick();
        }
      }
    };
    this.bannerService.add(geaMessage);
    return geaMessage;
  }
  reloadPage() {
    window.location.reload();
  }
  gotoProfile() {
    const isUserOnPortalPage = this.portalLink.includes(window.location.origin);
    if (isUserOnPortalPage) {
      void this.router.navigate([this.MEMBERSHIP_ACCEPT_PATH]);
      this.hideBanner();
      return;
    }
    window.open(`${this.portalLink}/${this.MEMBERSHIP_ACCEPT_PATH}`, '_blank');
  }
  hideBanner() {
    if (this.message) {
      this.bannerService.clear(this.message.key);
      this.message = undefined;
    }
  }
  isOnMemberShipAcceptedPage() {
    const membershipAcceptPath = `${this.portalLink}/${this.MEMBERSHIP_ACCEPT_PATH}`;
    return membershipAcceptPath.includes(window.location.pathname);
  }
  static ɵfac = function ActionRequiredService_Factory(t) {
    return new (t || ActionRequiredService)(i0.ɵɵinject(i1.BannerService), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.Router), i0.ɵɵinject('portalLink'));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ActionRequiredService,
    factory: ActionRequiredService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ActionRequiredService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.BannerService
  }, {
    type: i2.TranslateService
  }, {
    type: i3.Router
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['portalLink']
    }]
  }], null);
})();
